import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Dialog, DialogContent, DialogTrigger, Icon } from "@tenant/ui";
import { PerkDialogButtons } from "./PerkDialogButtons";
import { PerkDialogItem } from "./PerkDialogItem";
import styles from "./PerkDialogs.module.scss";

export const ExclusiveRatesDialog = () => {
  const [, cn] = useModuleBEM(styles, "PerkDialogs");
  const { t } = useI18nContext();
  const description = t("home.perks.exclusiveRates.description");
  const paragraphs = description.split("\n\n");

  return (
    <PerkDialogItem
      iconName={IconNameEnum.homepagePerkCenter}
      title={t("home.perks.exclusiveRates.title")}
    >
      <Dialog>
        <DialogTrigger className={cn("item-dialog-trigger")}>
          {t("home.perks.exclusiveRates.trigger")}
        </DialogTrigger>
        <DialogContent
          bottomFixedContent={<PerkDialogButtons showSeeRulesButton={false} />}
          className={cn("item-dialog-content")}
          showCloseButton={false}
        >
          <Icon
            iconName={IconNameEnum.homepagePerkCenter}
            className={cn("dialog-icon")}
            useCurrentColor={false}
          />
          <h2 className={cn("dialog-title")}>
            {t("home.perks.exclusiveRates.dialogTitle")}
          </h2>
          {paragraphs.map((paragraph, index) => (
            <p key={index} className={cn("dialog-section-text")}>
              {paragraph}
            </p>
          ))}
        </DialogContent>
      </Dialog>
    </PerkDialogItem>
  );
};
